<template>
	<dialog-slot
			title="Trip"
			is-full-screen
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<template #subTitle>
			<div class="customersHead-subTitleDialogTrip">
				<span> #<span class="id">{{ trip_id }}</span></span>
			</div>
		</template>
		<div class="dialogTripViewWrap">
			<div class="head"></div>
			<div class="main">
				<div class="left">

					<!--				General info -->
					<card-slot
							title="General info"
							icon="icon-document"
					>
						<div class="cardSlotMain">
							<item-info-row
									:is-item-icon="false"
									text="Trip:"
									:value="trip_id"
									margin="0"
									is-value-first-icon
									value-first-icon="number"
									value-first-icon-width="12"
									value-first-icon-height="12"
							></item-info-row>

<!--						customer-->
							<item-info-row
									:is-item-icon="false"
									text="Customer:"
									:value="customer"
									margin="0"
							></item-info-row>

<!--						driver-->
							<item-info-row
									:is-item-icon="false"
									text="Driver:"
									:value="driver"
									margin="0"
							></item-info-row>

<!--						Second driver-->
							<item-info-row
									v-if="secDriver"
									:is-item-icon="false"
									text="Second driver:"
									:value="secDriver"
									margin="0"
							/>

<!--						truck-->
							<item-info-row
									:is-item-icon="false"
									text="Truck:"
									:value="truck"
									margin="0"
									is-value-first-icon
									value-first-icon="number"
									value-first-icon-width="12"
									value-first-icon-height="12"
							></item-info-row>

<!--						trailer-->
							<item-info-row
									:is-item-icon="false"
									text="Trailer:"
									:value="trailer"
									margin="0"
									is-value-first-icon
									value-first-icon="number"
									value-first-icon-width="12"
									value-first-icon-height="12"
							></item-info-row>

<!--						trailer_type-->
							<item-info-row
									:is-item-icon="false"
									text="Trailer type:"
									:value="trailer_type"
									margin="0"
							></item-info-row>

<!--						dispatcher-->
							<item-info-row
									:is-item-icon="false"
									text="Dispatcher:"
									:value="dispatcher"
									margin="0"
							></item-info-row>

<!--							Total mileage-->
							<item-info-row
									:is-item-icon="false"
									text="Total mileage:"
									:value="totalMileage"
									margin="0"
									is-value-icon
									value-icon="icon_miles"
							/>
<!--							Total gross-->
							<item-info-row
									:is-item-icon="false"
									text="Total gross:"
									:value="totalGross"
									margin="0"
									is-value-first-icon
									value-first-icon="icon_dollars"
									value-first-icon-width="8"
									value-first-icon-height="16"
							/>
<!--							Total RMP-->
							<item-info-row
									:is-item-icon="false"
									text="Total RMP:"
									:value="totalRPM"
									margin="0"
									is-value-icon
									value-icon="icon_miles"
									is-value-first-icon
									value-first-icon="icon_dollars"
									value-first-icon-width="8"
									value-first-icon-height="16"
							/>
<!--							Bill factoring-->
							<item-info-row
									:is-item-icon="false"
									text="Bill to factoring:"
									:value="bill_factoring"
									margin="0"
									is-value-icon
									value-icon="icon_miles"
									is-value-first-icon
									value-first-icon="icon_dollars"
									value-first-icon-width="8"
									value-first-icon-height="16"
							/>

						</div>
					</card-slot>

					<card-slot
							title="Trip Timeline"
							icon="speedometer"
					>
						<NavigationAddress
								:items="getListItems()"
						></NavigationAddress>
					</card-slot>

					<card-slot
							title="Route Map"
							icon="routeMap"
					>
						<map-wrap
								v-if="isShowMap"
								:items="getMapItems"
						></map-wrap>
					</card-slot>

				</div>
				<div class="right">
					<load-view
							v-for="(item, index) in loads"
							:key="item.load_id"
							:index="index"
							:load="item"
							@updateClickButtonFilesView="onClickButtonFilesView"
							@updateNewItem="setNewItem($event, index)"
							@updatePaymentAddItem="onPaymentAddItem({index, item })"
							@updateEditItem="onEditItem($event,index)"
					/>
				</div>
			</div>

		</div>

		<preview-doc v-if="linkPreviewDoc" @clear-link="clearLinkPreviewDoc" :link-doc="linkPreviewDoc"></preview-doc>

		<payments-drawer
				v-if="isPaymentsDrawer"
				:active-item="activeItem"
				@updateSave="onPaymentsDrawerSave"
				@updateClose="onPaymentsDrawerClose"
				is-disabled-consider
		></payments-drawer>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				:textRemoveSave="textRemoveSave"
				:textRemoveClose="textRemoveClose"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import CardSlot from "@/shared/CardSlot/CardSlot.vue";
import moment from "moment-timezone";
import NavigationAddress from "@/components/Dispatch/Trips/DialogTrip/NavigationAddress/NavigationAddress.vue";
import MapWrap from "@/components/Dispatch/Trips/DialogTrip/MapWrap/MapWrap.vue";
import LoadView from "@/components/Dispatch/Trips/DialogTripView/LoadView.vue";
import PreviewDoc from "@/modules/invoices/preview.vue";
import { getAppUrl } from "@/services";
import { mapActions } from "vuex";
import PaymentsDrawer from "@/components/Dispatch/Trips/DialogTrip/Load/Payments/PaymentsDrawer.vue";
import { KEY, TEXT, TITLE } from "@/components/Dispatch/Trips/DialogTrip/constants";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

export default {
	name: "DialogTripView",
	components: { DialogRemove, PaymentsDrawer, PreviewDoc, LoadView, MapWrap, NavigationAddress, CardSlot, ItemInfoRow, DialogSlot },

	props: {
		trip: Object,
	},
	computed: {
		getMapItems() {
			const parseDate = (dateString) => {
				return new Date(dateString);
			};
			let information = [];

			this.loads.map(load => {
				const delivery = load.delivery.map(item => ({
					load_id: load.load_id,
					date: item.date_time,
					type: 'delivery',
					...item.loction
				}));
				const pickup = load.pickup.map(item => ({
					load_id: load.load_id,
					date: item.date_time,
					type: 'pickup',
					...item.loction
				}));
				information = information.concat(pickup);
				information = information.concat(delivery);
			});
			information.sort((a, b) => parseDate(a.date) - parseDate(b.date));
			const result = {
				start: `${ information[0].city }, ${ information[0].state }, ${ information[0].zip_code }`,
				end: `${ information[information.length - 1].city }, ${ information[information.length - 1].state }, ${ information[information.length - 1].zip_code }`,
				waypoints: information.slice(1, information.length - 1).map((item) => `${ item.city }, ${ item.state }, ${ item.zip_code }`),
			};
			return result;

		},
	},

	data: () => ({
		loads: [],

		trip_id: null,
		dispatcher: null,
		customer: null,
		driver: null,
		secDriver: null,
		truck: null,
		trailer: null,
		trailer_type: null,

		totalMileage: 0,
		totalGross: 0,
		totalRPM: 0,
		bill_factoring: 0,

		isShowMap: false,

		linkPreviewDoc: null,

		// dispatcher: null,
		division: null,
		division_id: null,
		// driver: null,
		frozen: null,
		// loads: null,
		mileage_trip: null,
		old_route: null,
		// secDriver: null,
		// trailer: null,
		// trip_id: null,
		// truck: null,

		activeLoad: null,
		activeItem: null,
		activeItemIndex: null,
		activeLoadIndex: null,
		ai_status: false,
		isPaymentsDrawer: false,

		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		textRemoveSave: null,
		textRemoveClose: null,
	}),

	watch: {
		trip: {
			immediate: true,
			handler(val) {
				if (!val) return;
				this.applyTrip(val);
			}
		}
	},

	methods: {
		...mapActions([
			'setAlert',
			'saveTrip',
		]),
		async onClickButtonFilesView({ key, item }) {
			if (key === "view") {
				console.log('%c [  item  ] ', 'color:#bada55', typeof item, item );
				this.linkPreviewDoc = getAppUrl + item.image;
				// this.linkPreviewDoc = item.url;
			}
		},
		clearLinkPreviewDoc() {
			this.linkPreviewDoc = null;
		},

		onClose() {
			this.$emit("updateClose");
		},

		applyTrip(payload) {
			const trip = payload.trip ? payload.trip : payload;

			let loads = [];

			if (Array.isArray(payload.loads)) {
				loads = payload.loads;
			} else if (Array.isArray(trip.loads)) {
				loads = trip.loads;
			}

			this.loads = loads;

			this.trip_id = trip.trip_id != null ? trip.trip_id : null;

			const getVal = (x) => {
				if (x && typeof x === "object" && "value" in x) {
					return x.value;
				}
				return x;
			};

			this.dispatcher = getVal(trip.dispatcher) || null;
			this.customer = getVal(trip.customer || trip.division) || null;
			this.driver = getVal(trip.driver) || null;
			this.secDriver = getVal(trip.secDriver) || null;
			this.truck = getVal(trip.truck) || null;
			this.bill_factoring = trip.bill_factoring || null;
			this.trailer = getVal(trip.trailer) || null;

			if (trip.trailer && trip.trailer.trailer_type) {
				this.trailer_type = trip.trailer.trailer_type;
			} else {
				this.trailer_type = null;
			}

			this.updateTotalGross();
			this.updateLoadTotalMileage();

			this.updateLoadGrossStart();
		},

		updateLoadTotalMileage() {
			this.totalMileage = 0;

			this.loads.forEach((obj) => {
				const mileageEmpty = Number(obj.mileage_empty || 0);
				const pickUpMileage = Number(obj.pick_up_mileage || 0);
				this.totalMileage += mileageEmpty + pickUpMileage;
			});

			this.updateTotalRPM();
		},

		updateTotalGross() {
			this.totalGross = 0;

			this.loads.forEach((load) => {
				this.totalGross += Number(load.gross || 0);
			});
		},

		updateLoadGrossStart() {
			this.loads.map(obj => {
				const { load_id, tarp } = obj;
				if (tarp) this.updateLoadGross(load_id);
			});
			this.isShowMap = true;
		},

		updateTotalRPM() {
			if (!this.totalGross || !this.totalMileage) {
				this.totalRPM = 0;
				return;
			}

			const totalRPM = Number(this.totalGross) / Number(this.totalMileage);
			this.totalRPM = totalRPM.toFixed(2);
		},

		getListItems() {
			const currentDate = moment();
			// Устанавливаем часовой пояс Чикаго (Central Time Zone)
			const chicagoTimezone = 'America/Chicago';
			currentDate.tz(chicagoTimezone);
			// Форматируем дату и время в желаемом формате 'YYYY-MM-DD HH:mm:ss'
			const formattedDateTime = currentDate.format('YYYY-MM-DD HH:mm:ss');
			const nowTime = {
				date: formattedDateTime,
				type: 'now'
			};
			const parseDate = (dateString) => {
				return new Date(dateString);
			};
			let information = [];

			this.loads.map(load => {
				const delivery = load.delivery.map(item => ({
					load_id: load.load_id,
					date: item.date_time,
					type: 'delivery',
					...item.loction
				}));
				const pickup = load.pickup.map(item => ({
					load_id: load.load_id,
					date: item.date_time,
					type: 'pickup',
					...item.loction
				}));
				information = information.concat(pickup);
				information = information.concat(delivery);
			});
			information.push(nowTime);
			information.sort((a, b) => parseDate(a.date) - parseDate(b.date));

			return information;
		},

		setNewItem(args, index) {
			const { e, id, name } = args;
			const iFile = e.target.files[0];
			const reader = new FileReader();

			reader.readAsDataURL(iFile);
			reader.onload = () => {
				this.file = {
					name: iFile.name,
					value: reader.result
				};
				const result = {
					created_at: null,
					dispatcher_id: null,
					dispatcher_name: null,
					image: null,
					load_id: null,
					load_image_id: null,
					to_invoice: null,
					status: 'new',
					description: this.file.name,
					newFile: this.file.value,
					typeName: name,
					type: id,
				};
				this.loads[index].file.push(result);
			};
		},

		async onSave() {

			const {
				dispatcher,
				division,
				division_id,
				driver,
				frozen,
				loads,
				mileage_trip,
				old_route,
				secDriver,
				trailer,
				trip_id,
				truck,
				bill_factoring,
				ai_status,
			} = this.trip.trip;

			const value = {
				dispatcher,
				division,
				division_id,
				driver,
				frozen,
				loads,
				mileage_trip,
				old_route,
				secDriver,
				trailer,
				trip_id,
				truck,
				bill_factoring,
				ai_status,
			};

			const id = await this.saveTrip(value);
			console.log('%c [  id  ] ', 'color:#bada55', typeof id, id );

			if (id) this.$emit("updateTripInfo", id);
			// this.isSaveStatus = true;
		},

		onPaymentAddItem({ index, item }) {

			this.activeItem = null;
			this.activeLoad = item;
			this.activeLoadIndex = index;

			this.isPaymentsDrawer = true;
		},
		onPaymentsDrawerClose() {
			this.isPaymentsDrawer = false;
			this.activeItem = null;
		},
		onPaymentsDrawerSave(args, editPayment) {
			const { amount, considerBoolean, msg, type } = args;
			const considerResult = considerBoolean ? 1 : 2;
			if (editPayment) {
				this.loads[this.activeLoadIndex].payments[this.activeItemIndex].amount = amount;
				this.loads[this.activeLoadIndex].payments[this.activeItemIndex].consider = considerResult;
				this.loads[this.activeLoadIndex].payments[this.activeItemIndex].msg = msg;
				this.loads[this.activeLoadIndex].payments[this.activeItemIndex].type = type;
			} else {
				const result = {
					amount,
					consider: considerResult,
					msg,
					type,
					create_at: null,
					id: null,
					status: "active",
					load_id: this.activeLoad.load_id
				};
				this.loads[this.activeLoadIndex].payments.push(result);
			}
			this.activeItem = null;
			this.isPaymentsDrawer = false;

			// this.updateLoadGross(this.activeLoad.load_id);
		},

		onEditItem(args, index) {
			console.log('%c [  args  ] ', 'color:#bada55', typeof args, args );
			const { key, item, nameComponent, itemIndex, load } = args;
			console.log('%c [  nameComponent  ] ', 'color:#bada55', typeof nameComponent, nameComponent );

			this.activeItem = item;
			this.activeItemIndex = itemIndex;
			this.activeLoad = load;
			this.activeLoadIndex = index;

			switch (key) {
				case "delete":
					this.titleRemove = TITLE.REMOVE_PAYMENT;
					this.textRemove = TEXT.REMOVE_PAYMENT;
					this.flagRemove = KEY.PAYMENT;
					this.textRemoveSave = 'YES';
					this.textRemoveClose = 'NO';
					this.isDialogRemove = true;
					break;
				case "edit":
					this.isPaymentsDrawer = true;
					break;
			}
		},

		onCloseRemove() {
			this.isDialogRemove = false;
		},
		onRemove() {

			this.isDialogRemove = false;

			switch (this.flagRemove) {
				case KEY.PAYMENT:
					this.activeItem.status = 'delete';
					// this.updateLoadGross(this.activeLoad.load_id);
					break;

			}
		},
	},

	mounted() {
		this.updateLoadGrossStart();
	},
};
</script>

<style scoped lang="scss">
.customersHead-subTitleDialogTrip {
	color: var(--card-color-sub-title);
	.id {
		color: var(--base-green);
	}
}
.dialogTripViewWrap {

	.main {
		display: grid;
		grid-template-columns: 450px 1fr;
		grid-gap: 10px;
		.left {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}
		.right {}

		.cardSlotMain {
			display: flex;
			flex-direction: column;
			gap: 6px;
		}
	}
	.line {
		.main {
			display: flex;
			flex-direction: column;
			gap: 6px;
		}
	}
}
</style>
